var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowCircleRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_29_209",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 31,
    height: 31
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_29_209)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5 19.7476L19.7476 15.5L15.5 11.2524L14.6107 12.1417L17.3232 14.8542H10.9792V16.1458H17.3232L14.6107 18.8583L15.5 19.7476ZM15.5042 27.125C13.8967 27.125 12.3854 26.82 10.9701 26.2099C9.5551 25.5998 8.32415 24.7718 7.27725 23.726C6.23035 22.6802 5.40164 21.4503 4.79111 20.0363C4.18037 18.6226 3.875 17.1119 3.875 15.5042C3.875 13.8967 4.18005 12.3854 4.79015 10.9701C5.40024 9.5551 6.2282 8.32415 7.27402 7.27725C8.31984 6.23035 9.54972 5.40164 10.9637 4.79111C12.3774 4.18037 13.8881 3.875 15.4958 3.875C17.1033 3.875 18.6146 4.18005 20.0299 4.79015C21.4449 5.40024 22.6759 6.2282 23.7227 7.27402C24.7696 8.31984 25.5984 9.54972 26.2089 10.9637C26.8196 12.3774 27.125 13.8881 27.125 15.4958C27.125 17.1033 26.82 18.6146 26.2099 20.0299C25.5998 21.4449 24.7718 22.6759 23.726 23.7227C22.6802 24.7696 21.4503 25.5984 20.0363 26.2089C18.6226 26.8196 17.1119 27.125 15.5042 27.125ZM15.5 25.8333C18.3847 25.8333 20.8281 24.8323 22.8302 22.8302C24.8323 20.8281 25.8333 18.3847 25.8333 15.5C25.8333 12.6153 24.8323 10.1719 22.8302 8.16979C20.8281 6.16771 18.3847 5.16667 15.5 5.16667C12.6153 5.16667 10.1719 6.16771 8.16979 8.16979C6.16771 10.1719 5.16667 12.6153 5.16667 15.5C5.16667 18.3847 6.16771 20.8281 8.16979 22.8302C10.1719 24.8323 12.6153 25.8333 15.5 25.8333Z",
    fill: "#AD7B28"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCircleRight);
export default __webpack_public_path__ + "static/media/arrow_circle_right.6e5baf2b7148a6706b681e5766366e37.svg";
export { ForwardRef as ReactComponent };